import { Col } from 'antd';
import * as React from 'react';

import { DataSearch } from '@appbaseio/reactivesearch';

const AttributeType = ({ data }: any) => {
  switch (data['TYPE']) {
    case 'TEXTORNUMBER':
      return <TextOrNumber data={data}/>;

    case 'YEAR_RANGE':
      return <YearRange data={data}/>;

    default:
      return <div/>;
  }
};

const YearRange = ({ data }: any) => {
  let divStyleLeft = {
    width: '48%',
    display: 'inline-block'
  };
  let spacerStyle = {
    width: '4%',
    display: 'inline-block'
  };
  let divStyleRight = {
    width: '48%',
    display: 'inline-block'
  };
  return (
    <Col span={15}>
      <div style={divStyleLeft}>
        <DataSearch
          componentId="fromYearAttributeSearch"
          dataField={data['FIELD_NAMES'][0]}
          placeholder="From year"
          autosuggest={false}
          showFilter={true}
          showIcon={false}
          filterLabel="From year"
          themePreset={'dark'}
          fuzziness={0}
          customQuery={(value, props) => {
            return value
              ? {
                query: {
                  range: {
                    yearFrom: {
                      gte: value
                    }
                  }
                }
              }
              : null;
          }}
        />
      </div>
      <div style={spacerStyle}/>
      <div style={divStyleRight}>
        <DataSearch
          componentId="toYearAttributeSearch"
          dataField={data['FIELD_NAMES'][1]}
          placeholder="To year"
          autosuggest={false}
          showFilter={true}
          showIcon={false}
          filterLabel="To year"
          themePreset={'dark'}
          fuzziness={0}
          customQuery={(value, props) => {
            return value
              ? {
                query: {
                  range: {
                    yearTo: {
                      lte: value
                    }
                  }
                }
              }
              : null;
          }}
        />
      </div>
    </Col>
  );
};

const TextOrNumber = ({ data }: any) => {
  if (data['FIELD_NAMES'][0] === 'dpNumber') {
    return (
      <Col span={15}>
        <DataSearch
          componentId="attributeSearch"
          dataField={data['FIELD_NAMES'][0] + '.keyword'}
          showFilter={true}
          filterLabel={data['DISPLAY_NAME']}
          themePreset={'dark'}
        />
      </Col>
    );
  } else {
    return (
      <Col span={15}>
        <DataSearch
          componentId="attributeSearch"
          dataField={data['FIELD_NAMES'][0] + '.lowercase'}
          showFilter={true}
          filterLabel={data['DISPLAY_NAME']}
          themePreset={'dark'}
        />
      </Col>
    );
  }
};

export default AttributeType;



// WEBPACK FOOTER //
// ./src/components/search/attributes/AttributeType.tsx